import swal from 'sweetalert';
import moment from 'moment';
import Consts from '../commons/Consts';

const Helpers = {

    authHeader(token, others) {
        return {Authorization: 'Bearer ' + token, ...(others || {})};
    },

    alert: {
        tell(type, title, message, buttons=undefined) {
            return new Promise((resolve, reject) => {
                swal({
                    title: title,
                    text: message,
                    icon: type,
                    className: 'max-w-[350px]',
                    buttons
                }).then(value => {
                    resolve(value);
                });
            });
        },

        error(message, buttons=undefined) {
            return Helpers.alert.tell('error', 'Erreur', message, buttons);
        },

        success(message, buttons=undefined) {
            return Helpers.alert.tell('success', 'Succès', message, buttons);
        },

        confirm(message) {
            return new Promise((resolve, reject) => {
                swal({
                    title: 'Confirmez !',
                    text: message,
                    icon: 'warning',
                    buttons: {
                        cancel: 'Annuler',
                        confirm: {
                            text: 'Je confirme',
                            value: true
                        }
                    }
                }).then((result) => {
                    if (result) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                });
            });
        }
    },

    parseDate(datestring) {
        const y = datestring.substring(0, 4);
        const m = datestring.substring(4, 6);
        const d = datestring.substring(6, 8);
        const h = datestring.substring(8, 10) || '00';
        const i = datestring.substring(10, 12) || '00';

        return moment(`${y}-${m}-${d} ${h}:${i}`);
    },

    parseDashedDate(datestring) {
        const y = datestring.substring(0, 4);
        const m = datestring.substring(5, 7);
        const d = datestring.substring(8, 10);
        const h = datestring.substring(11, 13) || '00';
        const i = datestring.substring(14, 16) || '00';
        const utcOffsetHours = moment().utcOffset() / 60;

        return moment.utc(`${y}-${m}-${d} ${h}:${i}`).utcOffset(utcOffsetHours);
    },

    parseLocalDate(str) {
        const [datePart, timePart] = str.split(" ");
        const [y, m, d] = datePart.split("-").map(Number);
        const [hh, mm, ss] = (timePart || "00:00:00").split(":").map(Number);
        return new Date(y, m - 1, d, hh, mm, ss);
    },

    filePath(dir, filename) {
        return `${Consts.basefile}/${dir}/${filename}`;
    },

    objToUrlParams(obj, ignoreNull=false, ignoreEmpty=true) {
        let str = [];

        for (let x in obj) {
            if (!obj[x]) {
                obj[x] === null && (!ignoreNull || (ignoreNull && obj[x] !== null)) && str.push(`${x}=${obj[x]}`);
                obj[x] === '' && !ignoreEmpty && str.push(`${x}=${obj[x]}`);
            }
            else {
                str.push(`${x}=${obj[x]}`);
            }

        }

        return str.join('&');
    },

    formatDate(dateString, includeTime=false, locale='fr-FR') {
        const d = new Date(dateString);
        const date = d.toLocaleDateString(locale);
        const time = d.toLocaleTimeString('fr-FR');
        return date + ( includeTime ? ' ' + time : '');
    },

    yearsAgo(dateString) {
        const p = new Date(dateString);
        const a = new Date();
        return a.getFullYear() - p.getFullYear();
    },

    formatToAmount(amount, separator=' ') {
        return amount.toString().split('').reverse().join('').match(/.{1,3}/g).join(separator).split('').reverse().join('')
    },

    addZero(number) {
        return (parseFloat(number) < 10 ? '0' : '') + number;
    },

    wrappScollPersist(el_class, func, add=0){
        const initScroll = document.querySelector('.' + el_class).scrollTop;
        func();

        setTimeout(() => {
            document.querySelector('.' + el_class).scrollTop = initScroll + add;
        }, 10);
    },

    splitArray(delimiter, arr) {
        let rest = [...arr];
        const result = [];

        const getDelimiterIndex = (d, a) => {
            return a.findIndex((x) =>
                typeof d === "object"
                    ? Object.keys(d).every((y) => d[y] === x[y])
                    : x === d
            );
        };

        while (getDelimiterIndex(delimiter, rest) > -1) {
            const idx = getDelimiterIndex(delimiter, rest);
            result.push(rest.slice(0, idx));
            rest = rest.slice(idx + 1);
        }

        rest.length && result.push(rest);
        return result;
    },

    capitalizeWords(arr) {
        return arr.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const rest = word.slice(1).toLowerCase();

            return firstLetter + rest;
        });
    },

    isEmail(string) {
        return /^[a-z0-9\.\-_]+@[\S]+$/.test(string);
    }

};

export default Helpers;
